import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@mui/material/Grid";
import AuthService from "Lib/API/Auth/index";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MemberService from "Lib/API/Member";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import { ReactComponent as Close } from "assets/icons/CloseFilter.svg";
import { MultiSelect } from "components/MultiSelect/MultiSelect";
import { defaultGenderOptions, defaultRelationshipOptions, defaultReligionOptions, defaultStatusOptions } from "constants/memberOptions.constants";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { CheckBox, CloseButton, CloseButtonWrapper, FilterSelectWrapper, Label } from "./Theme";

export const MemberFilters = ({
  isAccount,
  setOpenFilters,
  openFilters,
  formik,
  handleOpenFilters,
}) => {
  const generalOptions = localStorage.getItem('generalOptions')
  ? JSON.parse(localStorage.getItem('generalOptions'))
  : {};
  const getOptions = (key, defaultOptions) => {
    return {
      options: generalOptions?.[key]?.options || defaultOptions || [],
      hidden: generalOptions?.[key]?.hidden || false,
    }
  };

  const relationshipOptions = getOptions("Relationship", defaultRelationshipOptions);
  const genderOptions = getOptions("Sex", defaultGenderOptions);
  const statusOptions = getOptions("Status", defaultStatusOptions);
  const religionOptions = getOptions("Religion", defaultReligionOptions);
  

  const { getAccessTokenSilently } = useAuth0();
  const [archivedChecked, setArchivedChecked] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [catagoryTypes, setCatagoryTypes] = useState([]);
  const [accountBillingTypes, setAccountBillingTypes] = useState([]);

  const [accountlLoading, setAccountlLoading] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [catagoryLoading, setCatagoryLoading] = useState(false);
  const [accountBillingLoading, setAccountBillingLoading] = useState(false);
  const [accountTotal, setAccountTotal] = useState(null);
  const [contactTotal, setContactTotal] = useState(null);
  const [catagoryTotal, setCatagoryTotal] = useState(null);
  const [billingTotal, setBillingTotal] = useState(null);
  const [accountTags, setAccountTags] = useState([]);
  const [accountTagsLoading, setAccountTagsLoading] = useState(false);
  const [accountTagsTotal, setAccountTagsTotal] = useState(null);
  const [contactTags, setContactTags] = useState([]);
  const [contactTagsLoading, setContactTagsLoading] = useState(false);
  const [contactTagsTotal, setContactTagsTotal] = useState(null);
  const [search, setSearch] = useState({ value: "", type: "" });

  const { searchAction } = useSearch({ action: setSearch });

  //Account Data
  const AccountFilterItems = [
    {
      name: "Account Name",
      isOptinal: true,
      data: accounts,
      loading: accountlLoading,
      formikField: `account[accounts]`,
      variableForSave: "_id",
      formikKey: "accounts",
      total: accountTotal,
    },
    {
      name: "Account Contacts",
      isOptinal: true,
      data: contactData,
      loading: contactLoading,
      formikField: `account[contacts]`,
      variableForSave: "_id",
      formikKey: "contacts",
      total: contactTotal,
    },
    {
      name: "Account Category",
      isOptinal: true,
      data: catagoryTypes,
      loading: catagoryLoading,
      formikField: `account[category]`,
      variableForSave: "title",
      formikKey: "category",
      total: catagoryTotal,
    },
    {
      name: "Billing Type",
      isOptinal: true,
      data: accountBillingTypes,
      loading: accountBillingLoading,
      formikField: `account[billing_type]`,
      variableForSave: "title",
      formikKey: "billing_type",
      total: billingTotal,
    },
    {
      name: "Account Tags",
      isOptinal: true,
      data: accountTags,
      loading: accountTagsLoading,
      formikField: `account[accountTags]`,
      variableForSave: "title",
      formikKey: "accountTags",
      total: accountTagsTotal,
    },
    {
      name: "Contact Tags",
      isOptinal: true,
      data: contactTags,
      loading: contactTagsLoading,
      formikField: `account[contactTags]`,
      variableForSave: "title",
      formikKey: "contactTags",
      total: contactTagsTotal,
    }
  ];

  const [value, setValue] = useState("");

  const handleChange = () => {
    setArchivedChecked(!archivedChecked);
    if (archivedChecked === false) {
      formik.setFieldValue("account.archived", true);
    } else {
      const updatedObject = { ...formik.values.account };
      delete updatedObject.archived;
      formik.setFieldValue("account", updatedObject);
    }
  };
  // Account Api
  const getAccountName = async () => {
    const token = await getAccessTokenSilently();
    setAccountlLoading(true);
    await FinanceService.getACcountNames(token, search?.value)
      .then((res) => {
        if (res?.accounts) {
          const newArray = res.accounts.map((item) => ({
            title: item.family_name,
            id: item.account_id,
            ...item,
          }));
          setAccounts(newArray);
        }
        setAccountTotal(res?.total);
        setAccountlLoading(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
        setAccountlLoading(false);
        setAccounts([]);
      });
  };
  // Contact Api
  const getAccountContacts = async () => {
    const token = await getAccessTokenSilently();
    setContactLoading(true);
    await MemberService.getPeopleList(token, search?.value)
      .then((res) => {
        const newArray = res?.contacts?.map((item) => ({
          title: item.full_name,
          id: item._id,
        }));
        setContactData(newArray);
        setContactLoading(false);
        setContactTotal(res?.total);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
        setContactData([]);
        setContactLoading(false);
      });
  };
  //Account Category
  const getAccountCategory = async () => {
    const token = await getAccessTokenSilently();
    setCatagoryLoading(true);
    await MembersSettingService.getCatagoryListByType(
      null,
      token,
      search?.value
    )
      .then((res) => {
        const newArray = res?.result?.map((item) => ({
          title: item.title,
          id: item._id,
        }));
        setCatagoryTypes(newArray);
        setCatagoryTotal(res?.count);
        setCatagoryLoading(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
        setCatagoryTypes([]);
        setCatagoryLoading(false);
      });
  };
  const getBillingType = async (type) => {
    const token = await getAccessTokenSilently();
    setAccountBillingLoading(true);
    // Account Billing Api
    await FinanceSettingService.getAccountBillingTypes(token)
      .then((res) => {
        const newArray = res?.result?.map((item) => ({
          title: item?.title,
          id: item?._id,
        }));
        setAccountBillingTypes(newArray);
        setBillingTotal(res?.count);
        setAccountBillingLoading(false);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
        setAccountBillingTypes([]);
        setAccountBillingLoading(false);
      });
  };

    const getAccountTagsHandler = async () => {
        const token = await getAccessTokenSilently();
        setAccountTagsLoading(true);
        AuthService.getTags(
          'account',
            "",
            "",
          token
        )
          .then((res) => {
            const tags = res?.result;
            const filterTags = tags?.map((item) => {
                return {
                    title: item?.title,
                    id: item?._id,
                };
            });
            setAccountTags(filterTags);
            setAccountTagsTotal(res?.count);
          })
          .catch((err) => {
            toastr.error('Error', err?.data?.message || 'Something went wrong');
          }).finally(() => {
            setAccountTagsLoading(false);
        });
    };

     const getContactTagsHandler = async () => {
      const token = await getAccessTokenSilently();
      setContactTagsLoading(true);
      AuthService.getTags(
          'contact',
          "",
          "",
          token
      )
        .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
            return {
                title: item?.title,
                id: item?._id,
            };
        });
        setContactTags(filterTags);
        setContactTagsTotal(res?.count);
        })
        .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
        }).finally(() => {
            setContactTagsLoading(false);
        });
    };


  const handleFormikChange = (items, formikField, variableForSave) => {
    formik.setFieldValue(formikField, items);
  };
  useEffect(() => {
      getAccountName();
      getAccountContacts();
      getAccountCategory();
      getBillingType();
      getAccountTagsHandler();
      getContactTagsHandler();
  }, []);
  useEffect(() => {
    if (search?.type === "accounts") {
      getAccountName();
    } else if (search?.type === "contacts") {
      getAccountContacts();
    } else if (search?.type === "category") {
      getAccountCategory();
    } else if (search?.type === "billing_type") {
      getBillingType();
    }
  }, [search]);

  useEffect(() => {
    if (formik.values?.clear) {
      setArchivedChecked(false);
      setValue("");
    }
  }, [formik.values]);

  return (
    <>
      <CloseButtonWrapper>
        <CloseButton onClick={() => setOpenFilters(!openFilters)}>
          <Close onClick={handleOpenFilters} />
        </CloseButton>
      </CloseButtonWrapper>
      <FilterSelectWrapper>
      <Grid container spacing={7} columns={{ xs: 4, sm: 8, md: 12 }}>
        {AccountFilterItems.map((val) => (
          <Grid item xs={2} sm={2} md={3} key={val.name}>
            <MultiSelect
              placeholder="Select..."
              label={val.name}
              isOptinal={val.isOptinal}
              isCheckBoxOption={true}
              options={val?.data}
              loading={val?.loading}
              formikField={val.formikField}
              setOptions={setAccounts}
              variableForSave={val?.variableForSave}
              formik={formik}
              handleFormikChange={handleFormikChange}
              isAccount={true}
              formikKey={val.formikKey}
              searchAction={searchAction}
              total={val.total}
              isMultiple={true}
            />
          </Grid>
        ))}
        <Grid item xs={2} sm={2} md={3}>
          <CheckBox>
            <label className="check-box-container">
              <input
                type="checkbox"
                checked={formik.values.account?.archived}
                onChange={handleChange}
              />
              <span className="checkbox-checkmark"></span>
            </label>
            <Label>Archived Accounts</Label>
          </CheckBox>
        </Grid>
      </Grid>
      </FilterSelectWrapper>
    </>
  );
};
